import { createFileRoute, notFound } from '@tanstack/react-router'
import { z } from 'zod'
import { ssrProjectWork } from '@/server/ssr-project'
import { projectHead } from '@/lib/project-head'
import { CommunityProjectPage } from '@/components/ledger/CommunityProjectPage'

export const Route = createFileRoute(
  '/{-$locale}/community_/projects/$projectSlug',
)({
  validateSearch: z.object({ cursor: z.string().uuid().optional() }),
  loaderDeps: ({ search }) => ({ cursor: search.cursor }),
  loader: async ({ params, deps }) => {
    const data = await ssrProjectWork(params.projectSlug, deps.cursor)
    if (!data) throw notFound()
    return data
  },
  head: ({ params, match }) =>
    projectHead(
      params.projectSlug,
      params.locale ?? 'en-US',
      !!match.search.cursor,
    ),
  component: () => (
    <CommunityProjectPage
      slug={Route.useParams().projectSlug}
      work={Route.useLoaderData()}
      locale={Route.useParams().locale ?? 'en-US'}
      cursor={Route.useSearch().cursor}
    />
  ),
})
